export default __webpack_public_path__ + "static/allProjects8-c00f01c62a29b1bb1200b4e59c831892.png";